import React from 'react';
import './PaidTimeOff.css';

import Slideshow from '../../../components/Slideshow/Slideshow';

const paidTimeOff = ( props ) => (
	<section id="PaidTimeOff">
		<h2>Paid Time Off & Holidays</h2>
		<Slideshow slides={ props.slides } bgImages="assets/images/benefits/Carousel_" />
	</section>
);

export default paidTimeOff;



// WEBPACK FOOTER //
// ./src/pages/Benefits/PaidTimeOff/PaidTimeOff.js